import { default as ExplorationCTAWithImageSection } from '../cta-with-image/cta-with-image';
import { Title } from '../cta-with-image/cta-with-image.style';
import styled from 'styled-components';

export {
  Button,
  Image,
  ImageContainer,
  TextContainer,
} from '../cta-with-image/cta-with-image.style';

export const CTAWithImageSection = styled(ExplorationCTAWithImageSection)`
  ${Title} {
    max-width: 32rem;
  }
`;
